import { addressSchema } from './address.schema';

export default {
  type: 'object',
  properties: {
    data: {
      properties: {
        bankAccountOwner: {
          properties: {
            firstName: {
              fieldRequired: true,
              type: 'string',
              title: 'Imię'
            },

            lastName: {
              fieldRequired: true,
              type: 'string',
              title: 'Nazwisko'
            },

            fullName: {
              calc: '[this.firstName, this.lastName].filter(Boolean).join(" ")',
              type: 'string'
            },

            fullNameReversed: {
              calc: '[this.lastName, this.firstName].filter(Boolean).join(" ")',
              type: 'string'
            },

            hasPesel: {
              type: 'boolean',
              enum: [true, false],
              title: 'Czy posiada numer PESEL?',
              validationMessages: {
                enum: 'Wartość pola jest wymagana.'
              }
            },

            pesel: {
              disabled: '!this.hasPesel',
              fieldRequired: true,
              type: 'string',
              title: 'Numer PESEL'
            },

            identificationDocument: {
              disabled: 'this.hasPesel',
              type: 'object',
              properties: {
                type: {
                  fieldRequired: true,
                  type: 'string',
                  title: 'Rodzaj dokumentu'
                },
                number: {
                  fieldRequired: true,
                  type: 'string',
                  title: 'Numer dokumentu'
                }
              }
            },

            birthDate: {
              disabled: 'this.hasPesel',
              fieldRequired: true,
              format: 'date',
              title: 'Data urodzenia',
              type: 'string'
            },

            bankAccountNumber: {
              description: 'W przypadku autowypłaty należy pozostawić pole puste',
              fieldRequired: false,
              format: 'iban',
              title: 'Numer rachunku bankowego',
              type: 'string'
            },

            address: addressSchema
          },

          type: 'object'
        }
      },
      type: 'object'
    },

    id: {
      type: 'number',
      fieldRequired: true
    }
  }
};
